import React , {useEffect, useState} from 'react'
import Style from './NumberOrderDetail.module.css'
import Input from '../Input/Input'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPlus ,faMinus} from '@fortawesome/free-solid-svg-icons'
import { useForm } from 'react-hook-form'
import { UpdateProductCountInBasket } from '../../Api/BarestServices'
import { errorToast, succToast } from '../../Toast/Toast'

const NumberOrderDetail = (props) => {
    const {register , handleSubmit }=useForm()
    const onSubmit = (data) => {}
    const[number,SetNumber]=useState(0)
    const[gray,setGray]=useState(false)
    
    const path = window.location.pathname.split("/");

    useEffect(()=>{
        SetNumber(props.data.cart===null?0:props.data.cart)

    },[props.data.cart]) 
    

    const PlusCountHandler=()=>{
        setGray(true)
        if(props.data.cart===props.data.count){
            SetNumber(props.data.cart)
            setGray(false)
        }
        else{
            SetNumber(parseInt(number)+1)
            let addToCartInfo={
                supplier_id:props.supId,
                product_id:path[2],
                count:parseInt(number)+1
            }
            UpdateProductCountInBasket(addToCartInfo,(res)=>{
                if(res.status===0){
                    errorToast(res.message)
                    setGray(false)
                }
                else{
                    succToast('باموفقیت اضافه شد')
                    // props.dataUpdate()
                    setGray(false)
                }
            })
            
        }
       
        
    }
    const MinusCountHandler=()=>{
        setGray(true)
        if(number<1)
        {
            SetNumber(0)
            setGray(false)
        }
        else
        {
            SetNumber(parseInt(number)-1)
            let addToCartInfo={
                supplier_id:props.supId,
                product_id:path[2],
                count:parseInt(number)-1
            }
            UpdateProductCountInBasket(addToCartInfo,(res)=>{
                if(res.status===0){
                    errorToast(res.message)
                }
                else{
                    succToast('سفارش شما بروزرسانی شد')
                    // props.dataUpdate()
                    setGray(false)
                }
            })
        } 
    }
    return (
        <div className={Style.ProductCounterHolder}>
            <form onSubmit={handleSubmit(onSubmit)} className={Style.formHolder}>
                <div className={props.data.cart===props.data.count?Style.displayHandler:Style.plus} onClick={gray?null:PlusCountHandler}>< FontAwesomeIcon icon={faPlus} /></div>
                    <Input {...register('counter',{ required: true })} inputtype={'counter'} type={'number'} value={number===null?0:number} />
                <div className={Style.Minus} onClick={gray?null:MinusCountHandler}> <FontAwesomeIcon icon={faMinus} /></div>
            </form>
            
        </div>
    )
}
export default NumberOrderDetail
